module.exports = __webpack_public_path__ + "static/media/hcommerce.be173226.svg";